/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// if(document.querySelector('body').classList.contains('template-collection')){
// document.addEventListener('scroll' , function(){
//  console.log(window.pageYOffset); 
//   let header = document.getElementsByClassName('CollectionToolbar__Group')[0]; 

//     if (window.pageYOffset > 100) {    
//     if(document.querySelector('body').classList.contains('sticky')){
//     return;
//     } else{
//     document.querySelector('body').classList.add('sticky');
//     } 
    
//     }else{
      
//       if(document.querySelector('body').classList.contains('sticky')){
//        document.querySelector('body').classList.remove('sticky');
//       } else{
//         return;
//       }
//     }
// })

// }
// mobile menu issue 



// end mobile menu issue
if(document.querySelector('.template-product')){
document.querySelector('.product-description_title').addEventListener('click' , function(){
  
  let element = document.querySelector('.product-description_title');
  if(element.classList.contains('open')){
    element.classList.remove('open');
    document.querySelector('.ProductMeta__Description').style.height = '30px';

  } else {
    element.classList.add('open');
    document.querySelector('.ProductMeta__Description').style.height = 'auto';

  }
})
}

document.querySelector('.men').addEventListener('click' , function(){
document.querySelector('.women').classList.remove('active');
document.querySelector('.kids').classList.remove('active');
document.querySelector('.men').classList.add('active');
document.querySelector('.SidebarMenu__Nav-men').classList.add('active');
document.querySelector('.SidebarMenu__Nav-women').classList.remove('active');
document.querySelector('.SidebarMenu__Nav-kids').classList.remove('active');
document.querySelector('.Header__MainNav-men').classList.add('active');
document.querySelector('.Header__MainNav-women').classList.remove('active');                                                                     
document.querySelector('.Header__MainNav-kids').classList.remove('active');                                                                     
                                                                     
                                                                    
});
document.querySelector('.women').addEventListener('click' , function(){
document.querySelector('.men').classList.remove('active');
document.querySelector('.kids').classList.remove('active');
document.querySelector('.women').classList.add('active');
document.querySelector('.SidebarMenu__Nav-women').classList.add('active');
document.querySelector('.SidebarMenu__Nav-men').classList.remove('active');
document.querySelector('.SidebarMenu__Nav').classList.remove('active');
document.querySelector('.Header__MainNav-women').classList.add('active');
document.querySelector('.Header__MainNav-men').classList.remove('active');
document.querySelector('.Header__MainNav-kids').classList.remove('active');
  
});

document.querySelector('.kids').addEventListener('click', function() {
document.querySelector('.men').classList.remove('active');
document.querySelector('.women').classList.remove('active');
document.querySelector('.kids').classList.add('active');
document.querySelector('.SidebarMenu__Nav-kids').classList.add('active');
document.querySelector('.SidebarMenu__Nav-men').classList.remove('active');
document.querySelector('.SidebarMenu__Nav-women').classList.remove('active');
document.querySelector('.Header__MainNav-kids').classList.add('active');
document.querySelector('.Header__MainNav-men').classList.remove('active');
document.querySelector('.Header__MainNav-women').classList.remove('active');
});



  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("חובה לאשר כי הבנתי את תקנות האתר.");
        return false;
      }
    });


$('.Drawer__Header .Drawer__Title').on('click' , function(){
  
  $('.Drawer__Close').trigger('click');
  
})

$('.CollectionToolbar__Item--sort').on('click' , function(){
  $('body').addClass('dark');
})

$(document).on('click' , '#collection-sort-popover , .PageOverlay' , function(){
  $('body').removeClass('dark');
})

$(document).on('click' , '.size-popup' , function(){
  $('.size-popup').removeClass('open');
})

$(document).on('click' , '.size-chart img' , function(){
  $('.size-popup').addClass('open');
})

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

$(document).ready(function() {
    $('.HorizontalList .Linklist .Link--secondary').each( function(){
      var crtHref= $(this).attr('href');
      var pathname= jQuery(location).attr('href');    
      const slug = pathname.split('/').pop();    
      if(crtHref=='/collections/'+slug)
      {
        $(this).closest('.HorizontalList__Item').addClass('is-active');
      }
      
    })

  let urlMenu = getUrlVars()["view"];
  if(urlMenu == 'women'){
    $('.SidebarMenu__Nav-men').removeClass('active');
    $('.SidebarMenu__Nav-women').addClass('active');
  }
});



jQuery( ".gender-filter > .women" ).click(function() {
	 var url = "https://www.trash-tlv.com/?view=women";
	window.open(url,"_self");
});
jQuery( ".gender-filter > .men" ).click(function() {
	 var url = "https://www.trash-tlv.com";
	window.open(url,"_self");
});

jQuery( ".gender-filter > .kids" ).click(function() {
	 var url = "https://www.trash-tlv.com/collections/essentials-kids";
	window.open(url,"_self");
});
